import Handsontable from 'handsontable/base';
import { TextAlignment, VerticalAlignment } from '../../../../../../common/table/CellTypeConstants';
import { getAllCellsBetween } from '../tableCellSelectionUtils';
import { createTableCellEntry } from '../../../../../../common/table/utils/tableInitialisationUtils';
import { getCellTextAlignment } from '../tableCellFormattingUtils';
import { TABLE_CELL_DEFAULT_VERTICAL_ALIGNMENT } from '../../../../../../common/table/tableConstants';

/**
 * Determines if the provided text alignment is applied to all selected cells.
 */
export const isHotTableTextAlignmentApplied = (
    hotInstance: Handsontable | null | undefined,
    textAlignment: TextAlignment,
    locale: string,
    cellSelections = hotInstance?.getSelected(),
): boolean => {
    if (!hotInstance || !cellSelections) return false;

    return !getAllCellsBetween(cellSelections).some(({ row, col }) => {
        const { cellData = createTableCellEntry() } = hotInstance.getCellMeta(row, col);
        const hotCellValue = hotInstance.getDataAtCell(row, col); // For formulas, will return formula result

        return getCellTextAlignment(cellData, locale, hotCellValue) !== textAlignment;
    });
};

/**
 * Determines if the provided vertical alignment is applied to all selected cells.
 */
export const isHotTableVerticalAlignmentApplied = (
    hotInstance: Handsontable | null | undefined,
    verticalAlignment: VerticalAlignment,
    cellSelections = hotInstance?.getSelected(),
): boolean => {
    if (!hotInstance || !cellSelections) return false;

    return !getAllCellsBetween(cellSelections).some(({ row, col }) => {
        const { cellData = createTableCellEntry() } = hotInstance.getCellMeta(row, col);

        if (!cellData.verticalAlignment) return verticalAlignment !== TABLE_CELL_DEFAULT_VERTICAL_ALIGNMENT;

        return cellData.verticalAlignment !== verticalAlignment;
    });
};
